export const COLORS = {
  RED: 'bg-red-600',
  BLUE: 'bg-blue-600',
  YELLOW: 'bg-bright-yellow/80',
  ORANGE: 'bg-orange-500',
  GREEN: 'bg-green-600',
  PURPLE: 'bg-purple-600',
  BROWN: 'bg-stone-800'
}